import React, {useState, useEffect} from 'react'
import {useFirestore, useFirebase} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import {env} from '../../../constants/Environment';
import * as RouterActions from '../../../actions/RouterActions';
import * as StructureActions from '../../../actions/canvas/StructureActions';
import {OutcomeRow} from './outcomerow';
import { Table, Form, Button, Icon, Dropdown } from 'semantic-ui-react'
import _ from 'lodash';

export function Market(props){
    const firestore = useFirestore();
    const firebase = useFirebase();
    const dispatch = useDispatch();

    let outcomes = Object.values(props.outcomes);
    outcomes.sort((a, b) => parseInt(a.canvas.code) - parseInt(b.canvas.code));

    const [market, setMarket] = useState(null);

    useEffect(() => {
        setMarket(props.market);
    }, [props.market]);

    
    if(market === null)return null;

    let name = (typeof market.name !== 'undefined')
                        ?market.name
                        :(typeof market.canvas !== 'undefined' && typeof market.canvas.name !== 'undefined')
                            ?market.canvas.name
                            :(typeof market.canvas.canvas !== 'undefined')
                                ?market.canvas.canvas.name
                                :market.uid;

    const setMappings = (outcomeId, mappings) => {
        let copy = _.cloneDeep(market);
        copy.changed = true;

        if(mappings === null && typeof copy.mappings !== 'undefined' && typeof copy.mappings[outcomeId] !== 'undefined')
            delete copy.mappings[outcomeId];
        if(mappings !== null){
            if(typeof copy.mappings === 'undefined')
                copy.mappings = {};

            copy.mappings[outcomeId] = _.cloneDeep(mappings);
        }

        setMarket(copy);
    }

    const setName = (name) => {
        let copy = _.cloneDeep(market);
        copy.changed = true;
        copy.name = name;
        setMarket(copy);
    }

    const setConstraint = (constraint) => {
        let copy = _.cloneDeep(market);
        copy.changed = true;
        if(constraint === '-'){
            if(typeof copy.constraint !== 'undefined')
                delete copy.constraint;
        }else copy.constraint = constraint;
        setMarket(copy);
    }

    const constraintOptions = [
        {
            key: '-',
            text: 'Constraints des Events verwenden (standard)',
            value: '-'
        },
        {
            key: 'nc',
            text: 'Keine Constraints ausgeben',
            value: 'nc'
        },
        {
            key: '*',
            text: '*: Beliebiges Event/Markt',
            value: '*'
        },
        {
            key: 'powerplay',
            text: 'Powerplay',
            value: 'powerplay'
        },
        {
            key: 'cc+1',
            text: 'cc+1',
            value: 'cc+1'
        },
        {
            key: 'cc+2',
            text: 'cc+2',
            value: 'cc+2'
        }
    ];

    return (
        <div style={{
            margin: '1em'
        }}>
            <Form>
                <Form.Input label="Bezeichnung" placeholder="Name des Marktes" value={name} onChange={(e) => setName(e.target.value)} />
                <Dropdown label="Constraints" fluid selection placeholder="Welche Constraints sollen für diesen Markt verwendet werden?" options={constraintOptions} value={(typeof market.constraint === 'undefined')?'-':market.constraint} onChange={(e, {value}) => {
                    setConstraint(value);
                }} />
                <div style={{
                    marginTop: '0.5em'
                }}>
                    <Button><Icon name="filter" /> Constraint-Filter bearbeiten</Button>
                </div>
            </Form>
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>UID</Table.HeaderCell>
                        <Table.HeaderCell>Canvas-ID</Table.HeaderCell>
                        <Table.HeaderCell>Art</Table.HeaderCell>
                        <Table.HeaderCell>Clean</Table.HeaderCell>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Alternativ-Namen</Table.HeaderCell>
                        <Table.HeaderCell>Handicap</Table.HeaderCell>
                        <Table.HeaderCell>Markt</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                {
                    (_.filter(outcomes, (outcome) => (typeof outcome.canvas.code !== 'undefined' && outcome.canvas.code !== ''))).map((outcome) => <OutcomeRow onMappingsChanged={(mappings) => setMappings(outcome.canvas.code, mappings)} key={outcome.uid} outcome={outcome} market={market} />)
                }
                </Table.Body>
            </Table>
            <div style={{
                display: 'flex'
            }}>
                <div>
                    <Button icon labelPosition="left" onClick={(e) => dispatch(RouterActions.push('/canvas/markets/' + props.channel + '/' + props.sport))}><Icon name="left arrow" />Zurück zur Übersicht</Button>
                </div>
                <div style={{
                    flexGrow: 1
                }}>
                    <Button icon labelPosition="left" onClick={(e) => dispatch(StructureActions.save(firebase, props.channel, 'market', market.uid, _.pick(market, ['mappings', 'name', 'constraint'])))} fluid disabled={(typeof market.changed === 'undefined' || !market.changed)} primary><Icon name="save" />Änderungen speichern</Button>
                </div>
            </div>
        </div>
    );
}